import { domain } from "../auth/domain";

const getAuthHeaders = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Auth token missing; please log in again.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `JWT ${token}`,
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const detail = errorData.detail || errorData.message || "API request failed";
    throw new Error(detail);
  }
  return response.json();
};

const buildQuery = (params = {}) =>
  new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  ).toString();

export const fetchGroupTransactions = async ({ page = 1, page_size = 250, term_id, signal } = {}) => {
  const query = buildQuery({ page, page_size, term_id });
  const response = await fetch(`${domain}group-finance/group-transactions/?${query}`, {
    headers: getAuthHeaders(),
    signal,
  });
  return handleResponse(response);
};

export const fetchGroupAccount = async ({ signal } = {}) => {
  const response = await fetch(`${domain}group-finance/group-accounts/`, {
    headers: getAuthHeaders(),
    signal,
  });
  return handleResponse(response);
};

export const fetchDeskOfficerNotifications = async ({ page = 1, page_size = 20, signal } = {}) => {
  const query = buildQuery({ page, page_size });
  const response = await fetch(`${domain}notifications/?${query}`, {
    headers: getAuthHeaders(),
    signal,
  });
  return handleResponse(response);
};
